import { stringify } from 'qs';
import { container } from '@eureka/services/src/container';
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { PostTenantSelectInfosItem, PostTenantSelectInfosParams } from '../types/tenant';
import _ from 'lodash';

export interface IGetCheckSessionData {
  token: string;
  refresh_token: string;
}

export function postLoginSocialIndividualApi(
    source: string,
    data: Record<string, unknown>
) {
    return container.RnDHttp.post<IGetCheckSessionData>({
        url: `${import.meta.env.VITE_PASSPORT_URI}/login/social-individual/${source}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-API-Version': '1.0',
        },
        withCredentials: true,
        anonymous: true,
        params: {
            ...data,
            from: 'passport',
        },
    })
}

export function postLoginSocialIndividualPasswordApi(
    source: string,
    data: Record<string, unknown>
) {
    return container.RnDHttp.post<IGetCheckSessionData>({
        url: `${import.meta.env.VITE_PASSPORT_URI}/login/social-individual/${source}/password`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-API-Version': '1.0',
        },
        withCredentials: true,
        anonymous: true,
        params: {
            ...data,
            from: 'passport',
        },
    })
}

export function linkedInCheckPasswordApi(formData: {
  email: string;
  password: string;
  source: string;
  from: string;
}) {
    return container.RnDHttp.post({
        url: `${import.meta.env.VITE_PASSPORT_URI}/oauth/user/password`,
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        withCredentials: true,
        anonymous: true,
        data: stringify(formData),
    });
}

export function getPublicKeyApi(data = {}) {
    return container.RnDHttp.get<string>({
        url: `${import.meta.env.VITE_PASSPORT_URI}/public/request_public_key`,
        params: data,
        anonymous: true,
    })
}

export function postFreeRegisterApi(body: any, query: any) {
    return container.RnDHttp.post<any>({
        url: `${import.meta.env.VITE_PASSPORT_URI}/public/free-register`,
        method: 'POST',
        data: body,
        params: query,
        anonymous: true,
    })
}

// 获取租户列表
export function postTenantSelectInfosApi(params: PostTenantSelectInfosParams) {
    return container.RnDHttp.post<PostTenantSelectInfosItem[]>({
        url: `${import.meta.env.VITE_PASSPORT_URI}/public/tenant-select-infos`,
        withCredentials: true,
        data: params,
        anonymous: true,
    })
}
